
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { WindowType } from '../../../../util';
import { Cell, CellList, Line } from '../../../backend/backendapi';

declare var window: WindowType;

@Component
export default class TabGeneral extends Vue {
  @Prop({ required: true })
  readonly lines!: Line[];
  @Prop({ required: true })
  readonly cells!: CellList[];
  @Prop({ required: true })
  readonly cell!: Cell;

  get isMaintenance(): boolean {
    return window.application.check2.isMaintenanceMode;
  };

  get cellExistsWithName(): boolean {
    let lower = this.cell?.name?.toLocaleLowerCase();
    return this.cells.find(e => e.name?.toLocaleLowerCase() === lower && e.id !== this.cell?.id) !== undefined;
  }

  get cellExistsWithIdent(): boolean {
    let lower = this.cell?.ident?.toLocaleLowerCase();
    return !!lower?.length && this.cells.find(e => e.ident?.toLocaleLowerCase() === lower && e.id !== this.cell?.id) !== undefined;
  }

  get isFireProtection(): boolean {
    return window.application.permissions.misc.fireProtection;
  }
}
